<template>
  <div class="chart" :id="`echart-${_uid}`"  :ref="`echart-${_uid}`">
  </div>
</template>
<script>
require('echarts/lib/chart/bar');
require('echarts/lib/component/title');
require('echarts/lib/component/legend');
require('echarts/lib/component/markLine');
require('echarts/lib/component/tooltip');
export default {
  name: 'zxEchart',
  props: {
    Dwidth: 0,
    customColor: {
      type: String,
      default: '#3398DB'
    },
    series: {
      type: Array,
      default: () => []
    },
    avarage: 0,
    title: {
      default: '碗碟回测数据准确率'
    },
    acc_line: {
      type: String,
      default: '98'
    },
    date: {
      type: String
    }
  },
  data () {
    return {
      chart: null
    };
  },
  mounted () {
    this.drawLine();
    this.chart.on('click', (params) => {
      console.log(params);
      this.$emit('barClick', params.dataIndex);
    });
  },
  methods: {
    init () {
    },
    drawLine () {
      let target = this.$refs[`echart-${this._uid}`];
      this.chart = this.$echarts.init(target);
      this.chart.setOption(this.options);
    }
  },
  computed: {
    _dWidth () {
      return this.Dwidth;
    },
    xData () {
      return this.series.map((a) => a.dish_name || a.dish_native_name + '(碗碟库)');
    },
    yData () {
      return this.series.map((a) => Number.parseInt(a.dish_acc * 100));
    },
    options () {
      let that = this;
      return {
        title: {
          text: that.title,
          subtext: that.date,
          x: 'center'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            // console.log(params);
            let image = that.series[params[0].dataIndex].dish_image_url;
            let deleted = that.series[params[0].dataIndex].deleted;
            let total = that.series[params[0].dataIndex].total;
            let acc = that.series[params[0].dataIndex].dish_acc;
            let res = `${params[0].name} <br/>删除个数: ${deleted} <br/>总数: ${total} <br/>准确率: ${params[0].value
            }% <br/> 例图: <img src="${image}" alt="" width="50" height="50">`;
            return res;
          },
          textStyle: { color: '#ffff', align: 'left', fontSize: 14 }
        },
        color: this.customColor,
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            // data: [...xDatas],
            data: this.xData,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: -30
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
            // min: 80
          }
        ],
        series: [
          {
            type: 'bar',
            data: this.yData,
            barWidth: '50%',
            barMinHeight: 1,
            label: {
              show: true, // 开启显示
              position: 'top', // 在上方显示
              textStyle: { // 数值样式
                color: 'black',
                fontSize: 12
              }
            },
            markLine: {
              data: [
                {
                  name: '平均值',
                  xAxis: -1,
                  yAxis: this.avarage * 100,
                  lineStyle: {
                    color: '#38a7f0'
                  }},
                {
                  name: '准确率红线', xAxis: -1, yAxis: +that.acc_line}
              ],
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#ff0000'
                  },
                  label: {
                    show: true,
                    position: 'end'
                  }
                }
              }
            }
          }
        ]
      };
    }
  },
  watch: {
    _dWidth () {
      this.chart.resize();
    },
    options () {
      this.drawLine();
    }
  }
};
</script>
<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 400px;
}
</style>
